module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "fill-height": "",
      "px-1": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-card', {
    attrs: {
      "height": "100%"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Компания " + _vm._s(_vm.clientProps.nameShort) + "\n          ")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "profile"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "nameShort",
      "value": _vm.clientProps.nameShort,
      "readonly": "",
      "label": "Название",
      "type": "text"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "inn",
      "value": _vm.clientProps.inn,
      "readonly": "",
      "label": "ИНН",
      "type": "text"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email",
      "value": _vm.clientProps.email,
      "readonly": !_vm.profileEdit,
      "rules": _vm.clientEmailRules,
      "label": "Эл. почта",
      "type": "text",
      "clearable": _vm.profileEdit
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "phone",
      "value": _vm.clientProps.phone,
      "readonly": !_vm.profileEdit,
      "rules": _vm.phoneRules,
      "label": "Телефон",
      "type": "text",
      "clearable": _vm.profileEdit
    }
  })], 1), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "name": "address",
      "rows": "3",
      "value": _vm.clientProps.address,
      "readonly": !_vm.profileEdit,
      "label": "Адрес",
      "type": "text",
      "clearable": _vm.profileEdit
    }
  }), _vm._v(" "), _c('v-subheader', [_vm._v("Банковские реквизиты")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "bankDetails.account",
      "value": _vm.clientProps.bankDetails.account,
      "readonly": !_vm.profileEdit,
      "rules": _vm.accountRules,
      "label": "Р/с",
      "type": "text",
      "clearable": _vm.profileEdit
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "name": "bankDetails.bankName",
      "rows": "2",
      "value": _vm.clientProps.bankDetails.bankName,
      "readonly": !_vm.profileEdit,
      "label": "Название банка",
      "type": "text",
      "clearable": _vm.profileEdit
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "bankDetails.corrAccount",
      "value": _vm.clientProps.bankDetails.corrAccount,
      "readonly": !_vm.profileEdit,
      "rules": _vm.corrAccountRules,
      "label": "К/с",
      "type": "text",
      "clearable": _vm.profileEdit
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "bankDetails.bankBic",
      "value": _vm.clientProps.bankDetails.bankBic,
      "readonly": !_vm.profileEdit,
      "label": "БИК",
      "type": "text",
      "clearable": _vm.profileEdit,
      "rules": _vm.bankBicRules
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.profileEdit),
      expression: "!profileEdit"
    }],
    attrs: {
      "disabled": !_vm.getIsAllow({
        CLIENT_UPDATE: null
      })
    },
    on: {
      "click": function($event) {
        _vm.profileEdit = !_vm.profileEdit
      }
    }
  }, [_vm._v("Изменить")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.profileEdit),
      expression: "profileEdit"
    }],
    on: {
      "click": _vm.saveClientProfile
    }
  }, [_vm._v("Сохранить")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.profileEdit),
      expression: "profileEdit"
    }],
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Отменить")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.profileEdit),
      expression: "profileEdit"
    }],
    on: {
      "click": _vm.updateFromEgrul
    }
  }, [_vm._v("Обновить из ЕГРЮЛ")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-card', {
    attrs: {
      "height": "100%"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Представители\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.getIsAllow({
        AGENT_CREATE: null
      }),
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.addUser()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.clientAccounts), function(item, index) {
    return [_c('v-list-tile', {
      key: item.title,
      on: {
        "click": function($event) {
          return _vm.openUser(item.accountProfileId)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.nameShort))]), _vm._v(" "), _c('v-list-tile-sub-title', {
      staticClass: "text--primary"
    }), _vm._v(" "), _c('v-list-tile-sub-title', {
      staticClass: "text--primary"
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', [_vm._v(_vm._s(item.clientPhone))]), _vm._v(" "), _c('v-list-tile-action-text'), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v(_vm._s(item.clientEmail))])], 1)], 1), _vm._v(" "), (index + 1 < _vm.clientAccounts.length) ? _c('v-divider', {
      key: index
    }) : _vm._e()]
  })], 2)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-card', {
    attrs: {
      "height": "100%"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Настройка\n          ")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-flex', [_c('b', [_vm._v("Мониторинг контрагентов в ЕГРЮЛ.")])]), _vm._v(" "), _c('v-flex', [_vm._v("\n            Отслеживание изменений информации о контрагентах полезно для минимизации рисков при заключении договоров.\n            Для активации этой функциональности нажмите кнопку \"Включить\". После активации все \"Мои контрагенты\" будут поставлены на мониторинг и Вы будете получать рассылку об изменениях на почту компании.\n            ")])], 1), _vm._v(" "), _c('v-card-actions', [(!_vm.getClientMonitoring) ? _c('v-btn', {
    attrs: {
      "disabled": !_vm.getIsAllow({
        MONITORING_SWITCH: null
      })
    },
    on: {
      "click": function($event) {
        return _vm.switchMonitoring()
      }
    }
  }, [_vm._v("\n            Включить\n          ")]) : _vm._e(), _vm._v(" "), (_vm.getClientMonitoring) ? _c('v-btn', {
    attrs: {
      "disabled": !_vm.getIsAllow({
        MONITORING_SWITCH: null
      })
    },
    on: {
      "click": function($event) {
        return _vm.switchMonitoring()
      }
    }
  }, [_vm._v("\n            Отключить\n          ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-flex', [_c('b', [_vm._v("Рассылка документов.")])]), _vm._v(" "), (!_vm.clientProps.outgoing && !_vm.outgoingEdit) ? _c('div', [_c('v-flex', [_vm._v("\n            Позволяет в автоматическом режиме посылать документы после подготовки от имени клиента.\n            Для использования функциональности нужно создать почтовый ящик на одном из почтовых сервисах и указать параметры SMTP сервера. Желательно в этом почтовом ящике настроить переадресацию почты на основоой адрес компании, чтобы не потерять отклики адресатов.\n            ")]), _vm._v(" "), _c('v-flex', [_vm._v("\n            Для активации функциональности нажмите кнопку \"Включить\".\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.clientProps.outgoing || _vm.outgoingEdit) ? _c('div', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "height": "100%"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Почтовые ящики\n              ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.getIsAllow({
        MONITORING_SWITCH: null
      }),
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.openMailbox(null)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.clientMailboxes), function(item, index) {
    return [_c('v-list-tile', {
      key: item.title,
      on: {
        "click": function($event) {
          return _vm.openMailbox(item)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.name || item.user))]), _vm._v(" "), _c('v-list-tile-sub-title', {
      staticClass: "text--primary"
    }), _vm._v(" "), _c('v-list-tile-sub-title', {
      staticClass: "text--primary"
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', [_vm._v(_vm._s(item.host))]), _vm._v(" "), _c('v-list-tile-action-text'), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v(_vm._s(item.user))])], 1)], 1)]
  })], 2)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [(!_vm.clientProps.outgoing && !_vm.outgoingEdit) ? _c('v-btn', {
    attrs: {
      "disabled": !_vm.getIsAllow({
        MONITORING_SWITCH: null
      })
    },
    on: {
      "click": function($event) {
        _vm.outgoingEdit = true
      }
    }
  }, [_vm._v("\n            Включить\n          ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.outgoingEdit),
      expression: "outgoingEdit"
    }],
    on: {
      "click": _vm.saveClientProfileOutgoing
    }
  }, [_vm._v("Сохранить")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.outgoingEdit),
      expression: "outgoingEdit"
    }],
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Отменить")]), _vm._v(" "), (!_vm.outgoingEdit && _vm.clientProps.outgoing) ? _c('v-btn', {
    attrs: {
      "disabled": !_vm.getIsAllow({
        MONITORING_SWITCH: null
      })
    },
    on: {
      "click": function($event) {
        return _vm.turnOffOutgoing()
      }
    }
  }, [_vm._v("\n            Отключить\n          ")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-card', {
    attrs: {
      "height": "100%"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Дополнительная информация\n          ")])], 1), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.profileAddEdit),
      expression: "profileAddEdit"
    }]
  }, [_c('v-form', {
    ref: "profileAdd"
  }, [_c('v-textarea', {
    attrs: {
      "name": "about",
      "auto-grow": "",
      "rows": "1",
      "value": _vm.clientProps.about,
      "label": "О компании",
      "type": "text",
      "clearable": ""
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "website",
      "value": _vm.clientProps.website,
      "label": "Интернет сайт",
      "type": "text"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "name": "contacts",
      "auto-grow": "",
      "rows": "1",
      "value": _vm.clientProps.contacts,
      "label": "Контакты",
      "type": "text",
      "clearable": ""
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "name": "services",
      "auto-grow": "",
      "rows": "1",
      "value": _vm.clientProps.services,
      "label": "Товары и услуги",
      "type": "text",
      "clearable": ""
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "name": "price",
      "auto-grow": "",
      "rows": "1",
      "value": _vm.clientProps.price,
      "label": "Цены",
      "type": "text",
      "clearable": ""
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "prepend-icon": "attach_file",
      "auto-grow": "",
      "rows": "1",
      "name": "docs",
      "value": _vm.clientProps.docs,
      "label": "Публичные документы",
      "type": "text",
      "clearable": ""
    },
    on: {
      "click:prepend": _vm.openDocSelector
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "name": "tags",
      "auto-grow": "",
      "rows": "1",
      "value": _vm.clientProps.tags,
      "label": "Поисковые Теги",
      "type": "text",
      "clearable": ""
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "name": "other",
      "auto-grow": "",
      "rows": "1",
      "value": _vm.clientProps.other,
      "label": "Разное",
      "type": "text",
      "clearable": ""
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.profileAddEdit),
      expression: "!profileAddEdit"
    }]
  }, [_c('v-client-preview', {
    attrs: {
      "clientProfile": _vm.clientProps
    }
  }), _vm._v(" "), _c('div', {
    ref: "htmlDiv"
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.profileAddEdit),
      expression: "!profileAddEdit"
    }],
    attrs: {
      "disabled": !_vm.getIsAllow({
        CLIENT_UPDATE: null
      })
    },
    on: {
      "click": function($event) {
        _vm.profileAddEdit = !_vm.profileAddEdit
      }
    }
  }, [_vm._v("Изменить")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.profileAddEdit),
      expression: "profileAddEdit"
    }],
    on: {
      "click": _vm.saveClientProfileAdd
    }
  }, [_vm._v("Сохранить")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.profileAddEdit),
      expression: "profileAddEdit"
    }],
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Отменить")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51261ef2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/ClientProfile.vue
// module id = 1009
// module chunks = 1